/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Low
 * 
 * 1 = Normal
 * 
 * 2 = High
 * 
 * 3 = Urgent
 * 
 * 4 = Critical
 */
export enum SalesOrderLineItemPriority {
  Low = 0,
  Normal = 1,
  High = 2,
  Urgent = 3,
  Critical = 4
}
